import { render } from "./ShowLabelStatus.vue?vue&type=template&id=12d157d6&ts=true"
import script from "./ShowLabelStatus.ts?vue&type=script&lang=ts&external"
export * from "./ShowLabelStatus.ts?vue&type=script&lang=ts&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__